import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import StyledHtmlContent from '../common/StyledHtmlContent';

interface Feature {
  title: string;
  content: string;
}

interface Match {
  name: string;
  description: string;
}

const CockfightingU888Section: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('meta.cockfighting.title')}</title>
        <meta name="description" content={t('meta.cockfighting.description')} />
        <link rel="canonical" href="https://www.u888winbet.com/cockfighting" />
      </Helmet>
      <section className="bg-[#1a1a1a] text-white px-4 py-8 mt-[7rem] md:mt-[11rem] text-lg md:text-xl">
        {/* Title */}
        <h1 className="text-center text-2xl md:text-3xl font-bold text-[#ff5c00]">
          {t('cockfighting.title')}
        </h1>

        {/* Intro / Content */}
        <div className="mt-4 max-w-3xl mx-auto text-xl leading-relaxed text-center">
          <StyledHtmlContent html={t('cockfighting.intro')} />
        </div>

        <div className="w-full max-w-5xl mx-auto mb-10 px-4">
          <img
            src="/u888-banner.jpg"
            alt="U888 Promotion"
            className="rounded-md w-full h-auto"
          />
          <label className="block text-center italic mt-2 text-lg">
            {t('home.image_hint')}
          </label>
        </div>

        {/* Section 1 */}
        <h2 className="text-[#ff5c00] text-xl md:text-2xl font-bold text-center mt-10 mb-4">
          {t('cockfighting.section1.title')}
        </h2>
        <div className="max-w-3xl mx-auto leading-relaxed">
          <StyledHtmlContent html={t('cockfighting.section1.content')} />
        </div>

        {/* Section 2 - Features */}
        <h2 className="text-[#ff5c00] text-xl md:text-2xl font-bold text-center mt-10 mb-4">
          {t('cockfighting.section2.title')}
        </h2>
        <div className="max-w-3xl mx-auto leading-relaxed">
          <StyledHtmlContent html={t('cockfighting.section2.content')} />
        </div>
        {/* <div className="max-w-3xl mx-auto space-y-4">
          {(t('cockfighting.section2.features', { returnObjects: true }) as Feature[]).map(
            (feature, idx) => (
              <div key={idx}>
                <h3 className="font-semibold text-[#ffb347]">{feature.title}</h3>
                <p>{feature.content}</p>
              </div>
            )
          )}
        </div> */}

        {/* Section 3 - Popular Matches */}
        <h2 className="text-[#ff5c00] text-xl md:text-2xl font-bold text-center mt-10 mb-4">
          {t('cockfighting.section3.title')}
        </h2>
        <div className="max-w-3xl mx-auto leading-relaxed">
          <StyledHtmlContent html={t('cockfighting.section3.content')} />
        </div>
        {/* <div className="max-w-3xl mx-auto space-y-4">
          {(t('cockfighting.section3.matches', { returnObjects: true }) as Match[]).map(
            (match, idx) => (
              <div key={idx}>
                <h3 className="font-semibold text-[#ffb347]">{match.name}</h3>
                <p>{match.description}</p>
              </div>
            )
          )}
        </div> */}

        {/* Section 4 - Tips */}
        <h2 className="text-[#ff5c00] text-xl md:text-2xl font-bold text-center mt-10 mb-4">
          {t('cockfighting.section4.title')}
        </h2>
        <div className="max-w-3xl mx-auto leading-relaxed">
          <StyledHtmlContent html={t('cockfighting.section4.content')} />
        </div>
      </section>
    </>
  );
};

export default CockfightingU888Section; 